module.exports = __webpack_public_path__ + "img/bandeau.a437791b.png";